export default __webpack_public_path__ + "static/media/pulses_granted.c790a5f4.svg";